import * as React from 'react'
import { CircularProgress, Fade, FormControl, Grid, InputLabel, MenuItem, Select, makeStyles } from "@material-ui/core"
import { enums, TextButton, Elements } from "@tfo/common"
import CustomerPortalDialog from '../../../../../common/CustomerPortalDialog'
import { FormattedMessage, useIntl } from "react-intl"
import { ReasonForDepersonalization } from '@tfo/common/src/enums'
import { useState } from 'react'
import $http from '../../../../../../../utils/$http'
import { IIndividual } from '@tfo/common/src/models'
const { Label, Paragraph } = Elements

const useStyles = makeStyles({
    formControl: {
        width: '100%'
    },
    buttons: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingTop: '3rem'
    },
    confimationContent: {
        justifyContent: 'center',
        display: 'flex'
    }
})

const DepersonalizeDialog = ({ openModal, closeModal, orderId, individual, dialogTitle,  dialogBody, depersonalizationCompleted }: { openModal: boolean, closeModal: () => void, orderId: number, individual: IIndividual, dialogTitle: string, dialogBody: string, depersonalizationCompleted: () => void }) => {
    const intl = useIntl()
    const styles = useStyles()
    const depersonalizeReasons: Array<enums.ReasonForDepersonalization> = [enums.ReasonForDepersonalization.Canceled, enums.ReasonForDepersonalization.DuplicateOrder, enums.ReasonForDepersonalization.IncorrectOrder]
    const [depersonalizeData, setDepersonalizeData] = useState<{ orderId: number, reason?: enums.ReasonForDepersonalization }>({ orderId: orderId })
    const [responseMessage, setResponseMessage] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)
    const [confirmationModal, setConfirmationModal] = useState<boolean>(false)

    React.useEffect(() => {
        setDepersonalizeData({ ...depersonalizeData, reason: null })
    }, [openModal])

    const onChangeHandler = (event: React.ChangeEvent<{ name?: string; value: unknown; }>): void => {
        setDepersonalizeData({ ...depersonalizeData, reason: event.target.value as ReasonForDepersonalization })
    }

    const submitDepersonalize = (): void => {
        depersonalizeData.reason ? depersonalizeOrder() : displayError()
    }

    const depersonalizeOrder = (): void => {
        setLoading(true)
        $http.post<any>(`/Order/depersonalization`, {
            orderId: depersonalizeData.orderId,
            reason: depersonalizeData.reason,
            individualFirstName: individual.firstName,
            individualLastName: individual.lastName,
            individualEmail: individual.email
        })
            .then(() => {
                setLoading(false)
                setConfirmationModal(true)
            })
            .catch(() => {
                setResponseMessage('failed')
                setLoading(false)
                setTimeout(() => {
                    setResponseMessage('')
                }, 2000)
            })
    }

    const displayError = (): void => {
        setResponseMessage('no.selected.reason')
        setTimeout(() => {
            setResponseMessage('')
        }, 2000)
    }

    const exitDepersonalization = (): void => {
        setConfirmationModal(false)
        depersonalizationCompleted()
    }

    return (
        <>
            <CustomerPortalDialog
                open={openModal}
                onClose={closeModal}
                title={dialogTitle}
                content={
                    <Grid container>
                        <Grid item xs={12}>
                            <FormattedMessage
                                    id={dialogBody}
                                    values={{
                                    li: (...chunks) => (<li>{chunks}</li>),
                                    ul: (...chunks) => (<ul>{chunks}</ul>),
                                }} />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" className={styles.formControl}>
                                <InputLabel id="select-reason">{intl.formatMessage({ id: 'common.reason' })}</InputLabel>
                                <Select
                                    labelId="select-reason"
                                    id="select-reason"
                                    value={depersonalizeData?.reason ?? ''}
                                    label={intl.formatMessage({ id: 'common.reason' })}
                                    onChange={event => onChangeHandler(event)}
                                    error={responseMessage === 'no.selected.reason'}
                                >
                                    {depersonalizeReasons.map(reason => (
                                        <MenuItem key={reason} value={reason}>
                                            {intl.formatMessage({ id: `depersonalizeReason.${reason}` })}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        {loading ?
                            <Grid item xs={12} style={{ justifyContent: 'center', display: 'flex' }}>
                                <CircularProgress style={{ color: '#009B48' }} size={35} />
                            </Grid>
                            :
                            <Grid item xs={12} className={styles.buttons}>
                                <TextButton grey={true} onClick={submitDepersonalize}>{intl.formatMessage({ id: 'reportsitem.individual.depersonalize.dialog.button.yes' })}</TextButton>
                                <TextButton autoFocus blue={true} focused={true} onClick={closeModal}>{intl.formatMessage({ id: 'reportsitem.individual.depersonalize.dialog.button.no' })}</TextButton>
                            </Grid>
                        }
                        {responseMessage !== '' &&
                            <Fade in={responseMessage !== ''} timeout={{ enter: 300, exit: 1000 }}>
                                <Grid item xs={12} style={{ textAlign: 'center', paddingTop: '1rem' }}>
                                    <Label style={responseMessage === 'failed' ? { color: 'red' } : {}}>{intl.formatMessage({ id: `response.${responseMessage}` })}</Label>
                                </Grid>
                            </Fade>
                        }
                    </Grid>
                }
            />
            <CustomerPortalDialog
                open={confirmationModal}
                onClose={exitDepersonalization}
                content={
                    <Grid container>
                        <Grid item xs={12} className={styles.confimationContent} style={{ marginBottom: '2rem' }}>
                            <Paragraph bold>{intl.formatMessage({ id: 'reportsitem.individual.dialog.button.depersonalize.confirmation' })}</Paragraph>
                        </Grid>
                        <Grid item xs={12} className={styles.confimationContent}>
                            <TextButton blue={true} onClick={exitDepersonalization}>Ok</TextButton>
                        </Grid>
                    </Grid>
                }
            />
        </>
    )
}
export default DepersonalizeDialog